import { httpClient } from './httpClient'

type EnterpriseLead = {
  source?: string
  ref?: string
  firstName?: string
  lastName?: string
  phone?: string
  extraMessage?: string
  jobTitle?: string
  originUrl?: string
}

export const createEnterpriseLead = (enterpriseLead: EnterpriseLead) =>
  httpClient.post('/enterpriseLead', { enterpriseLead })
